import { Injectable, inject } from '@angular/core';
import { FilesClient } from '../generated-client/generated-client';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private filesClient = inject(FilesClient);


  downloadFile(fileId: string) {
    this.filesClient.downloadFileById(fileId)
      .subscribe(r => {
        saveAs(r.data, r.fileName, false);
      });
  }
}
